import { useContext, ComponentProps } from 'react';
import clsx from 'clsx';
import { OpButton } from 'components/customAntd/DLS/OpButton/OpButton';
import { OpSkeleton } from 'components/customAntd/DLS/OpSkeleton/OpSkeleton';
import { OpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface IOpFormButtonProps
  extends Omit<ComponentProps<typeof OpButton>, 'name'> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormButton = ({
  // Form Item props
  formItemClassName,

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  className,

  disabled,
  ...elementProps
}: IOpFormButtonProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useContext(OpFormContext);

  return (
    <OpForm.Item className={clsx('op-form-button', formItemClassName)}>
      {isDataLoading || isLoading ? (
        /** A placeholder in the shape of the component
         * so we can immediately render the structure of the form while
         * data is loading */
        <OpSkeleton.Button active block={elementProps.block} />
      ) : (
        /** The actual component that is rendered when we have the data */
        <OpButton
          disabled={isReadOnly || disabled}
          className={className}
          {...elementProps}
        />
      )}
    </OpForm.Item>
  );
};
